<template>
  <div>
    <login-text
      label="User Name"
      style="margin: 4.167vw 0"
      rule="^.{6,20}$"
      placeholder="Please enter your User Name"
      @inputChange="(res) => (name = res)"
    />

    <login-text
      label="ID"
      placeholder="Please enter your ID"
      rule="^.{6,20}$"
      @inputChange="(res) => (id = res)"
    />
    <login-text
      label="Password"
      placeholder="Please enter your Password"
      rule="^.{6,20}$"
      type="password"
      @inputChange="(res) => (password = res)"
    />

    <login-btn class="text-4xl" btntext ="Sign up" />
  </div>
</template>

<script>
import LoginText from "@/components/common/LoginText.vue";
import LoginBtn from "@/components/common/LoginBtn.vue";
export default {
  data() {
    return {
      username: "",
      id: "",
      password: "",
    };
  },
  components: {
    LoginText,
    LoginBtn,
  },
};
</script>

<style>
</style>